export default "__VITE_ASSET__idottuHj__"